/**
 * "REACT_APP_" - обязательный префикс, чтобы CRA подхватывал переменные из .env файла
 * Например: REACT_APP_MY_VAR
 */

export const IS_DEV = process.env.IS_DEV;

export const SENTRY_DSN = process.env.SENTRY_DSN || "";

export const SENTRY_ENV = process.env.SENTRY_ENV || "";

export const MEALS_API_BASE_URL = process.env.MEALS_API;

export const EMPLOYEES_API_BASE_URL = process.env.EMPLOYEES_API;

export const REACT_APP_PUSHGATEWAY_API = process.env.PUSHGATEWAY_API;
